import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;

    margin: 0.2rem 0 0 1.5rem;

    p{
        flex: auto;
        text-align: left;
    }
`